/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const START_TURBO_SCROLL = 'START_TURBO_SCROLL';
export const STOP_TURBO_SCROLL = 'STOP_TURBO_SCROLL';
export const START_GUIDE_PAGE_SCROLL = 'START_GUIDE_PAGE_SCROLL';
export const STOP_GUIDE_PAGE_SCROLL = 'STOP_GUIDE_PAGE_SCROLL';
